class FindRestaurantModalContent extends ViewBasic {
	constructor(options) {
		super(options);

		//set default variables
	}

	init() {
		this.addEvents();
	}

	addEvents() {
		Me.dispatch.subscribe('update.restaurant.list', (e, params) => this.updateVisual(e,params));
	}

	removeEvents() {

	}

	updateVisual(e, params){
		this.$el.addClass('with-map');
	}
}